import React, { FC } from 'react';
import styled from 'styled-components';
import { Text } from 'src/components/text/Text';
import { useBreakpoints } from 'logic/hooks/use-breakpoints';
import { ContentWrapper } from 'components/content-wrapper/ContentWrapper';
import { translate, translationKeys } from 'logic/translations/translations.service';
import { colors } from 'src/styles/colors';

const Content = styled.div<{ minTablet: boolean }>`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
`;

const TypeText = styled.div<{ minTablet: boolean }>`
  display: flex;
  flex-direction: column;
  align-items: ${({ minTablet }) => (minTablet ? 'flex-start' : 'center')};
`;

const Type = styled.div<{ minTablet: boolean }>`
  display: flex;
  flex-direction: ${({ minTablet }) => (minTablet ? 'row' : 'column')};
  align-items: center;
  justify-content: center;
  width: ${({ minTablet }) => (minTablet ? '520px' : '100%')};
  margin-bottom: ${({ minTablet }) => (minTablet ? '90px' : '48px')};
  & img {
    width: auto;
    margin-right: ${({ minTablet }) => (minTablet ? '24px' : '0')};
    height: ${({ minTablet }) => (minTablet ? '180px' : '230px')};
  }
  &:last-child {
    margin-right: 0;
  }
  &:nth-child(2n) {
    & img {
      margin-right: 0;
      margin-left: ${({ minTablet }) => (minTablet ? '24px' : '0')};
    }
    flex-direction: ${({ minTablet }) => (minTablet ? 'row-reverse' : 'column')};
  }
`;

const Pros = [
  {
    icon: '/icons/aboutus/type3.png',
    type: 'first',
  },
  {
    icon: '/icons/aboutus/type1.png',
    type: 'second',
  },
  {
    icon: '/icons/aboutus/type6.png',
    type: 'third',
  },
  {
    icon: '/icons/aboutus/type4.png',
    type: 'fourth',
  },
  {
    icon: '/icons/aboutus/type5.png',
    type: 'last',
  },
];

export const TypesSection: FC = () => {
  const { minTablet } = useBreakpoints();

  return (
    <ContentWrapper
      backgroundColor={colors.lightTeal}
      style={{ flexDirection: 'column' }}
      padding={minTablet ? '60px 0' : '32px 0'}
    >
      <Text
        color="blueGray"
        fontWeight={600}
        size={minTablet ? 38 : 26}
        textAlign="center"
        style={{ marginBottom: minTablet ? 70 : 48 }}
      >
        {translate(translationKeys.aboutus.typeTitle)}
      </Text>
      <Content minTablet={minTablet}>
        {Pros.map(({ icon, type }, idx) => (
          <Type key={idx} minTablet={minTablet}>
            <img src={icon} alt={translate(translationKeys.aboutus.typeCommunity[type].title)} />
            <TypeText minTablet={minTablet}>
              <Text
                color="black"
                fontWeight={600}
                size={18}
                textAlign={minTablet ? 'left' : 'center'}
                style={{ marginTop: minTablet ? 0 : 32, marginBottom: 6 }}
              >
                {translate(translationKeys.aboutus.typeCommunity[type].title)}
              </Text>
              <Text
                color="black"
                size={14}
                textAlign={minTablet ? 'left' : 'center'}
                style={{ width: minTablet ? 300 : '80%' }}
              >
                {translate(translationKeys.aboutus.typeCommunity[type].subTitle)}
              </Text>
            </TypeText>
          </Type>
        ))}
      </Content>
    </ContentWrapper>
  );
};
